export default __webpack_public_path__ + "static/media/Slider image 04.e151f65c.PNG";